import { motion } from "framer-motion";

export function Mark({ className = "h-9 w-8", draw = false, delay = 0 }) {
  const t = { duration: 1.4, ease: [0.65, 0, 0.35, 1], delay };
  return (
    <svg viewBox="0 0 40 48" className={className} fill="none" aria-hidden="true">
      <motion.path
        d="M7 45V20a13 13 0 0 1 26 0v25"
        stroke="currentColor"
        strokeWidth="1.6"
        initial={draw ? { pathLength: 0 } : false}
        animate={{ pathLength: 1 }}
        transition={t}
      />
      <motion.path d="M3 45h34" stroke="currentColor" strokeWidth="1.2" initial={draw ? { pathLength: 0 } : false} animate={{ pathLength: 1 }} transition={{ ...t, delay: delay + 0.4 }} />
      <motion.path
        d="M20 17s-6 8.2-6 12a6 6 0 0 0 12 0c0-3.8-6-12-6-12z"
        fill="currentColor"
        initial={draw ? { opacity: 0, y: -6 } : false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: delay + 0.9, ease: "easeOut" }}
      />
    </svg>
  );
}

export function Logo({ className = "", compact = false }) {
  return (
    <span className={`inline-flex items-center gap-3 whitespace-nowrap ${className}`} dir="ltr">
      <Mark className="h-8 w-7 text-[#C6A76A]" />
      <span className="flex flex-col leading-none">
        <span className="font-arabic-display text-[1.35rem] leading-none tracking-normal" dir="rtl">
          عطور رويحة
        </span>
        {!compact && <span className="mt-1 font-latin text-[0.58rem] tracking-[0.42em] text-[#C6A76A]">ATOR RWIHA</span>}
      </span>
    </span>
  );
}
